import React, { type ComponentType } from 'react';
import FireDevopsTargetingEvents from '@atlassian/jira-devops-fire-targeting-events/src/index.tsx';
import FireEngagementTargetingEvents from '@atlassian/jira-fire-engagement-targeting-events/src/index.tsx';
import LegacyIssueCreateTrackers from '@atlassian/jira-legacy-issue-create-trackers/src/index.tsx';
import { SpaResourceMetricsController } from '@atlassian/jira-spa-transition-resources-tracker/src/SpaResourceMetricsController.tsx';

export const Trackers: ComponentType<Record<string, never>> = () => (
	<>
		<SpaResourceMetricsController />
		<FireEngagementTargetingEvents />
		<FireDevopsTargetingEvents />
		<LegacyIssueCreateTrackers />
	</>
);

export default Trackers;
